import { PaginationProps } from 'hooks/usePagination';

export const INITIAL_PAGINATION_PROPS: PaginationProps = {
  page: 0,
  pageSize: 100,
  rowCount: 0
};
